/* Store-specific JS — Gadget Mint.
   Loaded with defer on every page from layout/theme.liquid. */

/* ================================================================
   ANNOUNCEMENT BAR ROTATOR
   ~30 lines, no libraries, no dependencies.
   • Shows one message at a time
   • Pauses on hover (desktop)
   • Pauses when the tab is hidden, so a backgrounded tab does no work
   • Skips auto-rotation entirely for prefers-reduced-motion users
   ================================================================ */
(function () {
  var bar = document.querySelector('[data-announcement]');
  if (!bar) return;

  var slides = bar.querySelectorAll('[data-announcement-slide]');
  if (slides.length < 2) return; /* nothing to rotate */

  var speed = parseInt(bar.getAttribute('data-speed'), 10);
  if (!speed || speed < 1000) speed = 4000;

  var index = 0;
  var timer = null;

  function show(next) {
    slides[index].classList.remove('is-active');
    index = next;
    slides[index].classList.add('is-active');
  }

  function advance() {
    show((index + 1) % slides.length);
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function start() {
    stop();
    timer = setInterval(advance, speed);
  }

  bar.addEventListener('mouseenter', stop);
  bar.addEventListener('mouseleave', start);
  bar.addEventListener('focusin', stop);
  bar.addEventListener('focusout', start);

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { stop(); } else { start(); }
  });

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce) start();
})();

/* ================================================================
   CATEGORY RAIL — arrow-button scroll controls
   Hides each arrow when there's nothing left to scroll to in that
   direction; no-ops safely when the section isn't on the page.
   ================================================================ */
(function () {
  var rails = document.querySelectorAll('[data-category-rail]');
  if (!rails.length) return;

  rails.forEach(function (rail) {
    var track = rail.querySelector('[data-rail-track]');
    var prev = rail.querySelector('[data-rail-prev]');
    var next = rail.querySelector('[data-rail-next]');
    if (!track || !prev || !next) return;

    function update() {
      var hasOverflow = track.scrollWidth > track.clientWidth + 4;
      prev.hidden = !hasOverflow || track.scrollLeft <= 4;
      next.hidden = !hasOverflow || track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    function scrollByAmount(dir) {
      track.scrollBy({ left: track.clientWidth * 0.7 * dir, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { scrollByAmount(-1); });
    next.addEventListener('click', function () { scrollByAmount(1); });
    track.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    update();
  });
})();
